import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { Calendar, User, ArrowRight } from 'lucide-react';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "From Farm to Global Markets: Our Visit to a GAP-Certified Grape Farm",
      excerpt: "At Cornerstone Exim, we believe that quality begins at the source. Last month, our team had the opportunity to visit a GAP-certified grape farm, gaining firsthand insight into the cultivation practices that ensure premium-quality grapes for international markets.",
      image: "https://customer-assets.emergentagent.com/job_merchant-cornerstone/artifacts/ldomet8t_7.png",
      date: "March 31, 2025",
      author: "Cornerstone Team",
      category: "Farm Visit",
      featured: true
    },
    {
      id: 2,
      title: "Visit to a GAP Certified Pomegranate Farm – A Learning Experience",
      excerpt: "Last month, we had the opportunity to visit a GlobalG.A.P. certified pomegranate farm in India as part of our preparation for the upcoming export season. Although it was not the harvest period, the farm was in the flowering stage, offering a valuable insight into the early phase of crop development.",
      image: "https://customer-assets.emergentagent.com/job_merchant-cornerstone/artifacts/k0fezkkb_10.png",
      date: "March 28, 2025",
      author: "Cornerstone Team",
      category: "Farm Visit",
      featured: false
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-emerald-950 via-green-950 to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            Insights & Stories
          </h1>
          <p className="text-xl text-emerald-100 max-w-3xl mx-auto">
            Stay updated with the latest news, insights, and stories from the world of agricultural exports
          </p>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
              >
                {/* Post Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {post.category}
                    </span>
                  </div>
                </div>

                {/* Post Content */}
                <div className="p-6">
                  {/* Meta Info */}
                  <div className="flex items-center space-x-4 text-sm text-gray-500 mb-3">
                    <div className="flex items-center space-x-1">
                      <Calendar size={16} />
                      <span>{post.date}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <User size={16} />
                      <span>{post.author}</span>
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-emerald-700 transition-colors">
                    {post.title}
                  </h3>

                  {/* Excerpt */}
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>

                  {/* Read More Link */}
                  <Link 
                    to={`/blog/${post.id}`}
                    className="flex items-center space-x-2 text-emerald-700 font-semibold hover:text-emerald-800 transition-colors group"
                  >
                    <span>Read More</span>
                    <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </article>
            ))}
          </div>

          {/* Coming Soon Message */}
          <div className="mt-16 text-center">
            <div className="bg-white rounded-xl shadow-md p-8 max-w-2xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">More Articles Coming Soon</h3>
              <p className="text-gray-600 mb-6">
                We're working on bringing you more valuable insights about agricultural exports, market trends, and industry best practices.
              </p>
              <Link 
                to="/#contact"
                className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
              >
                Subscribe for Updates
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
